export default function ErrorPage(){
    return (
        <h1> Ops! Página não encontrada!</h1>
    )

}